import { render, staticRenderFns } from "./ProxyView.vue?vue&type=template&id=b9d2c754&scoped=true"
import script from "./ProxyView.ts?vue&type=script&lang=ts&external"
export * from "./ProxyView.ts?vue&type=script&lang=ts&external"
import style0 from "./ProxyView.vue?vue&type=style&index=0&id=b9d2c754&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b9d2c754",
  null
  
)

export default component.exports